export default __webpack_public_path__ + "static/media/Ni_2020-7-1.b7c33daf.png";